import React from 'react'
import $$ from "cmn-utils";

/** 权限过滤器 */
export default ({ action, children }) => {
    let ret = false;
    const permissions = $$.getStore("permissions") || []
    if (action && action.length > 0) {
        if (Array.isArray(action)) {
            let purview = true;
            for (let i = 0; i < action.length; i++) {
                purview = permissions.includes(action[i].toUpperCase());
                if (!purview) break;
            }
            ret = purview;
        } else if (Object.prototype.toString.call(action) === `[object String]`) {
            ret = permissions.includes(action.toUpperCase());
        }
    }
    return children ? (ret ? children : '') : ret;
}
